import { convexQuery } from '@convex-dev/react-query';
import { useQuery } from '@tanstack/react-query';
import { api } from '~/convex/_generated/api';
import { useRevenuecat } from '../revenuecat/provider';

export const useCanRecord = () => {
  const { isSubscribed, isLoading: isSubscribedLoading } = useRevenuecat();
  const { data: canCreateReport, isLoading: isLoadingCanCreateReport } =
    useQuery(convexQuery(api.reports.canCreateReport, {}));

  return {
    canRecord: isSubscribed || canCreateReport?.canCreate,
    isLoading: isSubscribedLoading || isLoadingCanCreateReport,
    numberOfRecordings: canCreateReport?.numberOfRecordings,
    reportLimit: canCreateReport?.limit,
    isUnlimitedReports: canCreateReport?.isUnlimited ?? false,
  };
};
